package com.mgacreative.hotel.feature.finance.di

import com.mgacreative.hotel.feature.finance.ui.FinanceViewModel
import com.mgacreative.hotel.feature.finance.ui.CashRegisterViewModel
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

fun getFinanceFeatureModule() = module {
    viewModel { FinanceViewModel(get(), get(), null) }
    viewModel { CashRegisterViewModel(get()) }
}
